import { DemoModalVariants as DMV } from '../constants/demoModal'
import { DemoModalVariants } from '@dtx-company/true-common/src/types/demoModal'
import { LockModalVariants } from '@dtx-company/inter-app/src/constants/lockModal'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { getPlanTypeName } from '../utils/getPlanTypeName'
import React from 'react'

export const ProFeatureWrapperTooltip: React.FC<{
  tooltip?: {
    header: string
    body: string
  }
}> = ({ tooltip }) => (
  <>
    <Text color="primary.white" variant="body/small" fontWeight="bold" mb="4px">
      {tooltip?.header}
    </Text>
    <Text color="primary.white" variant="body/small">
      {tooltip?.body}
    </Text>
  </>
)

// `Pro` here is used to mean any paid feature across Pro & Pro+
export type ProFeatures = LockModalVariants | DemoModalVariants
export const ProFeatures = { ...LockModalVariants, ...DMV }

const PRO = getPlanTypeName(PlanType.PRO)
const PRO_PLUS = getPlanTypeName(PlanType.PRO_PLUS_ORG)

export const ProFeatureWrapperTooltips: {
  [key in ProFeatures]?: {
    header: string
    body: string
  }
} = {
  [ProFeatures.FC_WHITELABEL]: {
    header: `Upgrade to ${PRO_PLUS} to remove the Flowcode branding from the eye of your code.`,
    body: 'The privacy policy link at the bottom of the code will be retained for security purposes'
  },
  [ProFeatures.FC_PRO_COLORS]: {
    header: `${PRO} Feature: Additional color options`,
    body: `Upgrade to ${PRO} to access more color options for your Flowcodes.`
  },
  [ProFeatures.FC_PRO_BULK_CODE_CREATION]: {
    header: `${PRO} Feature: Make many Flowcodes`,
    body: `Upgrade to ${PRO} to create a batch of multiple Flowcodes.`
  },
  [ProFeatures.FP_PRO_COLORS]: {
    header: `${PRO} Feature: Additional color options`,
    body: `Upgrade to ${PRO} to access more color options for your Flowpage.`
  },
  [ProFeatures.FP_PRO_FONTS]: {
    header: `${PRO} Feature: Additional Font Options`,
    body: `Upgrade to ${PRO} to access more font options for your Flowpage.`
  },
  [ProFeatures.FP_PRO_PRIVACY_DEINDEXING]: {
    header: `${PRO} Feature: Remove your Flowpage from Google Search results`,
    body: `Upgrade to ${PRO} to access deindexing.`
  }
  // - Save this for an easier time.
  // [ProFeatures]: {
  //   header: '',
  //   body: ''
  // },
}

export const CRMTooltip: React.FC<{ planType: PlanType; copy: string }> = ({ planType, copy }) => (
  <>
    <Text color="primary.white" variant="body/small" fontWeight="bold" mb="4px">
      {getPlanTypeName(planType)} Feature: {copy} Integration
    </Text>
    <Text color="primary.white" variant="body/small">
      Upgrade to {getPlanTypeName(planType)} to automate marketing with {copy}
    </Text>
  </>
)

export const FlowpageCustomTermsTooltip: React.FC = () => (
  <>
    <Text color="primary.white" variant="body/small" fontWeight="bold" mb="4px">
      {PRO} Feature: Custom Terms and Conditions
    </Text>
    <Text color="primary.white" variant="body/small">
      Upgrade to {PRO} to link to your terms and conditions or a PDF.
    </Text>
  </>
)

export const FlowpageProCRMIntegrationTooltip: React.FC = () => (
  <>
    <Text color="primary.white" variant="body/small" fontWeight="bold" mb="4px">
      {PRO} Feature: Contact Collection Integrations
    </Text>
    <Text color="primary.white" variant="body/small">
      Upgrade to {PRO} to access Google Sheets, Mailchimp, and Flowpage integrations.
    </Text>
  </>
)

export const FlowpageProDuplicationTooltip: React.FC = () => (
  <>
    <Text color="primary.white" variant="body/small" fontWeight="bold" mb="4px">
      {PRO} Feature: Flowpage Duplication
    </Text>
    <Text color="primary.white" variant="body/small">
      Upgrade to {PRO} to duplicate your Flowpages.
    </Text>
  </>
)

export const FlowpageProGoogleSheetsTooltip: React.FC = () => (
  <>
    <Text variant="body/small" color="primary.white" fontWeight="700" mb="5px">
      {PRO} Feature: Google Sheets Integration
    </Text>
    <Text variant="body/small" color="primary.white">
      Upgrade to {PRO} to also collect Contact Information in a Google Sheet.
    </Text>
  </>
)
